import { useEffect } from 'react'
import { QueryHookOptions, QueryTuple } from '@apollo/client'
import { isLoadingData } from '~api'
import { POLL_INTERVAL } from './Details.consts'

interface useDetailsQueryProps<TData, TVariables> {
  useLazyQuery: (baseOptions?: QueryHookOptions<TData, TVariables>) => QueryTuple<TData, TVariables>
  variables: TVariables
}

export default function useDetailsLazyQuery<TData, TVariables>({ useLazyQuery, variables }: useDetailsQueryProps<TData, TVariables>) {
  const [getData, response] = useLazyQuery({
    variables,
    notifyOnNetworkStatusChange: true,
    pollInterval: POLL_INTERVAL,
  })

  useEffect(() => {
    getData()
  }, [getData])

  const { networkStatus, data = {} as TData } = response

  return {
    isLoading: isLoadingData(networkStatus),
    data,
  }
}
